import React from 'react'
import PrivateLayout from '../components/PrivateLayout'

const WorkAddPodcast = (): JSX.Element => {
  // const [selectedOption, setSelectedOption] = useState('en')

  return (
    <PrivateLayout>
      <div className="content">
        <div className="row gy-3 mb-6 justify-content-between">
          <div className="col-md-9 col-auto">
            <h3 className="mb-2 text-1100">Templeton Religion Trust</h3>
          </div>
        </div>

        <h3 className="mb-4">Podcast</h3>
        <div className="row">
          <div className="col-xl-9">
            <form className="row g-3 mb-6">
              <div className="col-12">
                <div className="form-floating">
                  <input className="form-control" id="floatingInputGrid" type="text" placeholder="Title" />
                  <label htmlFor="floatingInputGrid">Title</label>
                </div>
              </div>

              <div className="col-12">
                <div className="form-floating">
                  <textarea
                    className="form-control"
                    id="floatingProjectOverview"
                    placeholder=""
                    style={{ height: '150px' }}
                  ></textarea>
                  <label htmlFor="floatingProjectOverview">Description</label>
                </div>
              </div>

              <div className="col-sm-6 col-md-4 gy-6">
                <div className="form-floating">
                  <div className="form-floating">
                    <input className="form-control" id="floatingInputBudget" type="text" placeholder="Publisher" />
                    <label htmlFor="floatingInputBudget">Publisher</label>
                  </div>
                </div>
              </div>

              <div className="col-sm-6 col-md-4 gy-6">
                <div className="form-floating">
                  <select
                    className="form-select"
                    id="floatingSelectPrivacy" // value={selectedOption} onChange={handleChange}
                  >
                    <option value="">Select category</option>
                    <option value="en">Technology</option>
                    <option value="fr">Business</option>
                    <option value="ja">Comedy</option>
                  </select>
                  <label htmlFor="floatingSelectPrivacy">Genre/Category</label>
                </div>
              </div>

              <div className="col-sm-6 col-md-4 gy-6">
                <div className="flatpickr-input-container">
                  <div className="form-floating">
                    <input
                      className="form-control datetimepicker"
                      id="floatingInputStartDate"
                      type="text"
                      placeholder="end date"
                      data-options='{"disableMobile":true}'
                    />
                    <label className="ps-6" htmlFor="floatingInputStartDate">
                      Publication Date
                    </label>
                    <span className="uil uil-calendar-alt flatpickr-icon text-700"></span>
                  </div>
                </div>
              </div>

              <div className="col-sm-6 col-md-4">
                <div className="form-floating">
                  <select className="form-select" id="floatingSelectPrivacy">
                    <option>Select language</option>
                    <option value="en">English</option>
                    <option value="fr">French</option>
                    <option value="ja">Japanese</option>
                  </select>
                  <label htmlFor="floatingSelectPrivacy">Language</label>
                </div>
              </div>

              <div className="col-sm-6 col-md-4">
                <div className="form-floating">
                  <input className="form-control" id="floatingInputBudget" type="text" placeholder="URL" />
                  <label htmlFor="floatingInputBudget">URL</label>
                </div>
              </div>

              <div className="col-sm-6 col-md-4">
                <div className="form-floating">
                  <input className="form-control" id="floatingInputBudget" type="text" placeholder="DOI" />
                  <label htmlFor="floatingInputBudget">ID</label>
                </div>
              </div>

              <div className="row col-12 gy-3 bg-white pb-6 mt-6">
                <h3 className="mb-4">Hosts</h3>

                <div className="col-sm-6 col-md-4">
                  <div className="form-floating">
                    <input className="form-control" id="firstName" type="text" placeholder="First Name" />
                    <label htmlFor="firstName">First Name</label>
                  </div>
                </div>
                <div className="col-sm-6 col-md-4">
                  <div className="form-floating">
                    <input className="form-control" id="lastName" type="text" placeholder="Last Name" />
                    <label htmlFor="lastName">Last Name</label>
                  </div>
                </div>
                <div className="col-sm-6 col-md-4">
                  <div className="form-floating">
                    <select className="form-select" id="floatingSelectPrivacy">
                      <option>Select role</option>
                      <option value="1">Primary</option>
                      <option value="2">Additional</option>
                    </select>
                    <label htmlFor="floatingSelectPrivacy">Role</label>
                  </div>
                </div>
                <div className="col-sm-6 col-md-4">
                  <div className="form-floating">
                    <input className="form-control" id="orcId" type="text" placeholder="ORCID" />
                    <label htmlFor="orcId">ORCID</label>
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 ">
                  <a className="fw-bold fs--1 mt-4" href="#!">
                    <span className="text-danger-300" data-feather="user-minus"></span>
                  </a>
                </div>
                <hr className="bg-200 mb-4 mt-4" />

                <div className="col-sm-6 col-md-4">
                  <div className="form-floating">
                    <input className="form-control" id="firstName" type="text" placeholder="First Name" />
                    <label htmlFor="firstName">First Name</label>
                  </div>
                </div>
                <div className="col-sm-6 col-md-4">
                  <div className="form-floating">
                    <input className="form-control" id="lastName" type="text" placeholder="Last Name" />
                    <label htmlFor="lastName">Last Name</label>
                  </div>
                </div>
                <div className="col-sm-6 col-md-4">
                  <div className="form-floating">
                    <select className="form-select" id="floatingSelectPrivacy">
                      <option>Select role</option>
                      <option value="1">Primary</option>
                      <option value="2">Additional</option>
                    </select>
                    <label htmlFor="floatingSelectPrivacy">Role</label>
                  </div>
                </div>
                <div className="col-sm-6 col-md-4">
                  <div className="form-floating">
                    <input className="form-control" id="orcId" type="text" placeholder="ORCID" />
                    <label htmlFor="orcId">ORCID</label>
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 ">
                  <a className="fw-bold fs--1 mt-4" href="#!">
                    <span className="" data-feather="user-plus"></span>
                  </a>
                </div>
                <hr className="bg-200 mb-4 mt-4" />
              </div>

              <div className="col-12 gy-6">
                <div className="row g-3 justify-content-end">
                  <div className="col-auto">
                    <button className="btn btn-phoenix-primary px-5">Cancel</button>
                  </div>
                  <div className="col-auto">
                    <button className="btn btn-primary px-5 px-sm-15">Create Work</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>

        <footer className="footer position-absolute">
          <div className="row g-0 justify-content-between align-items-center h-100">
            <div className="col-12 col-sm-auto text-center">
              <p className="mb-0 mt-2 mt-sm-0 text-900">
                <span className="d-none d-sm-inline-block"></span>
                <span className="d-none d-sm-inline-block mx-1">&nbsp;</span>
                <br className="d-sm-none" />
                2023 &copy;
                <a className="mx-1" href="https://www.lotusrise.org/">
                  Lotus Rise
                </a>
              </p>
            </div>
          </div>
        </footer>
      </div>
    </PrivateLayout>
  )
}

export default WorkAddPodcast
